/* MyGiftz — pijlknoppen voor horizontale rijen (okt 2026) */
(function () {
  function init(root) {
    root.querySelectorAll('[data-mg-scroller]').forEach(function (wrap) {
      if (wrap.__mgInit) return;
      wrap.__mgInit = true;
      var row = wrap.querySelector('[data-mg-row]');
      var prev = wrap.querySelector('[data-mg-prev]');
      var next = wrap.querySelector('[data-mg-next]');
      if (!row) return;
      var step = function () { return Math.max(row.clientWidth * 0.85, 200); };
      var update = function () {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
